import api from './apiSetup';

export const purchaseBundle = (bundleId, paymentInfo) => {
  return api('/purchase', {
    method: 'POST',
    body: JSON.stringify({
      bundleId,
      ...paymentInfo
    })
  });
};

export const purchaseTemplate = (templateId, paymentInfo) => {
  return api('/purchase/template', {
    method: 'POST',
    body: JSON.stringify({
      templateId,
      ...paymentInfo
    })
  });
};

export const purchaseUltimate = paymentInfo => {
  return api('/purchase/ultimate', {
    method: 'POST',
    body: JSON.stringify({
      ...paymentInfo
    })
  });
};

export const confirmPaymentIntent = (paymentIntentId, invoiceId) => {
  return api('/purchase/confirm', {
    method: 'POST',
    body: JSON.stringify({
      stripePi: paymentIntentId,
      invoice_id: invoiceId
    })
  });
};
